
webpack.register(
    'components/leaderboard/statistics/strokes-text/strokes-text',
    function() {
        return require('components/leaderboard/statistics/strokes-text/strokes-text');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/leaderboard/statistics/strokes-text/strokes-text'/>\r\n\r\n<strokes-text-chart\r\n    title=\"strokes\"\r\n    name=\"strokes gained\"\r\n    {modal-title}=\"getInfoTitle\"\r\n    {description}=\"getInfoText\"\r\n    {sub-name}=\"getSubTitle\"\r\n    {rank}=\"rank\"\r\n    {value}=\"value\"\r\n>\r\n</strokes-text-chart>\r\n");